import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { ServiceCard } from "@/components/ServiceCard";
import { CATEGORIES, servicesByCategory } from "@/data/site";

export default function Services() {
  return (
    <>
      <Seo
        title="Spa Services & Massage Menu — Manikonda, Hyderabad | Ody Luxurious Spa"
        description="All 17 spa services in Manikonda: Swedish, Thai, deep tissue & Balinese massages, chocolate & four hand massage, reflexology, body scrubs, wraps, 24K gold facial, private jacuzzi."
        keywords="spa services Manikonda, massage menu Hyderabad, Swedish massage, Thai massage, deep tissue, Balinese massage, chocolate massage, four hand massage, body scrub, gold facial, jacuzzi"
      />
      <PageHero
        eyebrow="The Complete Menu"
        title="Seventeen ways to disappear for an hour"
        subtitle="Five curated categories of therapy — each delivered in a private suite by certified hands. Prices are shared personally, on call or WhatsApp."
        crumbs={[{ label: "Services" }]}
      />
      {CATEGORIES.map((cat) => (
        <section key={cat.slug} className="py-20 sm:py-24 odd:bg-alabaster">
          <div className="max-w-7xl mx-auto px-5 sm:px-8">
            <div className="flex flex-wrap items-end justify-between gap-6 mb-12">
              <div className="max-w-2xl">
                <Reveal>
                  <Eyebrow>{cat.eyebrow}</Eyebrow>
                </Reveal>
                <Reveal delay={0.08}>
                  <h2 className="mt-4 font-serif font-normal tracking-tight text-ink text-2xl sm:text-3xl lg:text-4xl">
                    {cat.name}
                  </h2>
                </Reveal>
                <Reveal delay={0.15}>
                  <p className="mt-4 text-sm sm:text-base leading-relaxed text-stone2">{cat.description}</p>
                </Reveal>
              </div>
              <Reveal delay={0.2}>
                <Link
                  to={`/services/${cat.slug}`}
                  data-testid={`services-cat-link-${cat.slug}`}
                  className="group inline-flex items-center gap-2 rounded-full border border-bronze/25 px-6 py-3 text-[0.7rem] uppercase tracking-[0.2em] text-bronze transition-colors duration-300 hover:bg-bronze hover:text-cream"
                >
                  View category
                  <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
              </Reveal>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {servicesByCategory(cat.slug).map((s, i) => (
                <ServiceCard key={s.slug} service={s} index={i} />
              ))}
            </div>
          </div>
        </section>
      ))}
    </>
  );
}
